import { NavLink } from '../nav-link/NavLink';

const TransferNavLink = () => {
  return (
    <NavLink to="/transfers/new_transfer" activeWhen={loc => loc.pathname.startsWith('/transfers')}>
      <NavLink.Icon name="Transfer" />
      <NavLink.Text>Transfers</NavLink.Text>
    </NavLink>
  );
};

export default TransferNavLink;
